import moment from 'moment-timezone';

export const LAST_REFRESHED_TIME = 'last_refreshed_time';
export const BID_TYPES = {
  MAX_BID: 'maxBid',
  CURRENT_BID: 'bidNow',
};

export const getLastRefreshedTime = () => {
  const timeStr = localStorage.getItem(LAST_REFRESHED_TIME);
  const lastRefreshedFormattedTime = moment(parseInt(timeStr, 10)).format('h:mm:ss A');
  return `Last refreshed ${lastRefreshedFormattedTime} `;
};
